import { Button } from "@mantine/core";

const UPLOAD_DOC_BASE = "https://asc360.com/covers/upload-documents";

const isSuccessStatus = (status) => String(status || "").toUpperCase() === "SUCCESS";

const TravellerUploadDocCell = ({ row }) => {
  if (!isSuccessStatus(row.status) || !row.uuid) return null;

  const href = `${UPLOAD_DOC_BASE}/${row.uuid}/`;
  const hasDoc = Boolean(row.cover_document);

  return (
    <Button
      component="a"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      variant={hasDoc ? "subtle" : "filled"}
      color="orange"
      size="compact-xs"
      onClick={(event) => event.stopPropagation()}
    >
      {hasDoc ? "View Doc" : "Upload"}
    </Button>
  );
};

export default TravellerUploadDocCell;
